import React from 'react';
import { Box, TextField, MenuItem, Typography } from '@mui/material';
import { Question } from '../../../../types/course';

interface CodeEditorProps {
    question: Question;
    onChange: (updatedQuestion: Question) => void;
}

const LANGUAGES = [
    { value: 'javascript', label: 'JavaScript' },
    { value: 'python', label: 'Python' },
    { value: 'html', label: 'HTML' },
    { value: 'css', label: 'CSS' },
    { value: 'java', label: 'Java' },
    { value: 'cpp', label: 'C++' },
];

const CodeEditor: React.FC<CodeEditorProps> = ({ question, onChange }) => {
    return (
        <Box>
            <TextField
                select
                fullWidth
                label="Language"
                value={question.codeLanguage || 'javascript'}
                onChange={(e) => onChange({ ...question, codeLanguage: e.target.value })}
                sx={{ mb: 2 }}
            >
                {LANGUAGES.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>

            <TextField
                fullWidth
                multiline
                rows={4}
                label="Initial Code Snippet (Optional)"
                value={question.codeSnippet || ''}
                onChange={(e) => onChange({ ...question, codeSnippet: e.target.value })}
                sx={{ mb: 2, fontFamily: 'monospace' }}
                placeholder="// Code to start with..."
            />

            <TextField
                fullWidth
                multiline
                rows={4}
                label="Expected Solution (for validation)"
                value={question.codeSolution || ''}
                onChange={(e) => onChange({ ...question, codeSolution: e.target.value })}
                sx={{ fontFamily: 'monospace' }}
                helperText="Used to check if the student's code contains specific keywords or structure."
            />
        </Box>
    );
};

export default CodeEditor;
